import { useApi } from '~/composables/useApi';

/**
 * PA 레포트 API
 * - 타입이 명시된 파라미터 사용
 * - URLSearchParams를 통한 데이터 전송
 */
export function usePaReportApi() {
  return {
    /**
     * 레포트 데이터 조회
     * @param year - 조회 년도
     * @param month - 조회 월
     * @param deptId - 부서 ID
     * @param userId - 구성원 ID (선택적)
     */
    fetchReportData: (year: string, month: string, deptId: string, userId: string | null) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      params.append('deptId', deptId);
      if (userId) {
        params.append('userId', userId);
      }

      return useApi('/api/pa/report/getReportData.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 인덱스 그룹 상세 조회 (차트 클릭 시)
     * @param year - 조회 년도
     * @param month - 조회 월
     * @param deptId - 부서 ID
     * @param userId - 구성원 ID (선택적)
     * @param indexGrp - 인덱스 그룹 코드 ('F', 'O', 'C', 'U', 'S')
     */
    fetchIndexGroupDetail: (
      year: string,
      month: string,
      deptId: string,
      userId: string | null,
      indexGrp: string,
    ) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      params.append('deptId', deptId);
      if (userId) {
        params.append('userId', userId);
      }
      params.append('indexGrpId', indexGrp);
      return useApi('/api/pa/report/getIndexGroupDetail.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 구성원 목록 조회
     * @param year - 조회 년도
     * @param month - 조회 월
     */
    fetchMemberList: (year: string, month: string, deptId: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      params.append('month', month);
      params.append('deptId', deptId);
      return useApi('/api/pa/report/getMemberList.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 년도/월 옵션 목록 조회
     */
    fetchSearchOptions: (year: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      return useApi('/api/pa/report/getSearchOptions.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },

    /**
     * 부서 목록 조회
     */
    fetchDepartmentList: (year: string) => {
      const params = new URLSearchParams();
      params.append('year', year);
      return useApi('/api/pa/report/getDeptList.do', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });
    },
  };
}
